export const epistoFavorites = [
  { n: ["white right pointing backhand index", "point_right"], u: "1f449" },
  { n: ["thumbs up sign", "+1", "thumbsup"], u: "1f44d" },
  { n: ["thumbs down sign", "-1", "thumbsdown"], u: "1f44e" },
  { n: ["white down pointing backhand index", "point_down"], u: "1f447" },
  { n: ["ok hand sign", "ok_hand"], u: "1f44c" },
  { n: ["waving hand sign", "wave"], u: "1f44b" },
  { n: ["person with folded hands", "pray"], u: "1f64f" },
  { n: ["grinning face", "grinning"], u: "1f600" },
  { n: ["man"], u: "1f468" },
  { n: ["woman"], u: "1f469" },
  { n: ["rocket"], u: "1f680" },
  { n: ["electric light bulb", "bulb"], u: "1f4a1" },
  { n: ["round pushpin", "round_pushpin"], u: "1f4cd" },
  { n: ["left-pointing magnifying glass", "mag"], u: "1f50d" },
  { n: ["white heavy check mark", "white_check_mark"], u: "2705" },
  { n: ["cross mark", "x"], u: "274c" },
  { n: ["no entry sign", "no_entry_sign"], u: "1f6ab" },
  { n: ["calendar", "date"], u: "1f4c5" },
  { n: ["money bag", "moneybag"], u: "1f4b0" },
  { n: ["herb"], u: "1f33f" },
  { n: ["anticlockwise downwards and upwards open circle arrows", "arrows_counterclockwise"], u: "1f504" },
  { n: ["speech balloon", "speech_balloon"], u: "1f4ac" },
  { n: ["bar chart", "bar_chart"], u: "1f4ca" },
  { n: ["mobile phone with rightwards arrow at left", "calling"], u: "1f4f2" },
  { n: ["stopwatch"], u: "23f1-fe0f" },
  { n: ["birthday cake", "birthday"], u: "1f382" },
  { n: ["house building", "house"], u: "1f3e0" },
  { n: ["graduation cap", "mortar_board"], u: "1f393" },
  { n: ["briefcase"], u: "1f4bc" },
];
